export const getDeliveryEtaId = (productTypeId: string, printTypeIds: string[]) =>
  `${productTypeId}|${printTypeIds.join()}`;
